import { GalleryAPIResponse, LightboxRootObject, LookbookAPIResponse, } from '@moment/net/softbox-types.ts';
import { resolvedLanguage } from '@/i18n.ts';
import { API_URL, DEFAULT_CKEY, getInitializedMomentFetcher, } from './fetch-contstants.ts';
import { RoutePrefetchQueryOptions } from '../routes/types.ts';

export type GalleryRouteParams = { lookbookId: string; title: string };

export const generateFetchLookbookQuery = (
  options?: RoutePrefetchQueryOptions & GalleryRouteParams
) => {
  return async (): Promise<GalleryAPIResponse | undefined> => {
    const momentFetcher = await getInitializedMomentFetcher();
    const logger = options ? options.logger : undefined;
    const lookbookId = options ? options.lookbookId : undefined;
    const lang = options ? options.lang : undefined;
    logger?.log(`generateFetchLookbookQuery, lookbookId = ${lookbookId}`);
    const language = lang || resolvedLanguage('en');
    let galleryData: GalleryAPIResponse | undefined;

    try {
      // First, fetch the lookbook data
      const lookbookUrl = `${API_URL}/wp/v1/lookbook/${lookbookId}?ckey=${DEFAULT_CKEY}&mp_lang=${language}`;

      const lookbookRes = await momentFetcher.fetch(lookbookUrl);
      const lookbookResponse: LookbookAPIResponse = await lookbookRes.json();

      logger?.log(
        `generateFetchLookbookQuery - lookbook fetched from\n${lookbookUrl}`
      );

      galleryData = {
        lookbookResponse: lookbookResponse,
      };
    } catch (error) {
      console.error('Error fetching data:', error);
      throw error;
    }

    return galleryData;
  };
};

export const generateFetchRecirculationQuery = (
  options?: RoutePrefetchQueryOptions
) => {
  return async (): Promise<LightboxRootObject | undefined> => {
    const momentFetcher = await getInitializedMomentFetcher();
    const logger = options ? options.logger : undefined;
    const lang = options ? options.lang : undefined;
    const language = lang || resolvedLanguage('en');

    try {
      const recirculationUrl = `${API_URL}/wp/v1/daily?ckey=${DEFAULT_CKEY}&mp_lang=${language}&sched=recirculation`;
      const recirculationRes = await momentFetcher.fetch(recirculationUrl);
      const recirculationResponse: LightboxRootObject =
        await recirculationRes.json();
      logger?.log(
        `generateFetchRecirculationQuery - recirculation fetched from\n${recirculationUrl}`
      );
      return recirculationResponse;
    } catch (error) {
      console.error('Error fetching recirculation data:', error);
      throw error;
    }
  };
};

export const generateFetchLookbookRecirculationQuery = (
  options?: RoutePrefetchQueryOptions
) => {
  return async (): Promise<LightboxRootObject | undefined> => {
    const momentFetcher = await getInitializedMomentFetcher();
    const logger = options ? options.logger : undefined;
    const lookbookId = options ? options.lookbookId : undefined;
    const lang = options ? options.lang : undefined;
    const language = lang || resolvedLanguage('en');
    logger?.log(
      `generateFetchLookbookRecirculationQuery, lookbookId = ${lookbookId}`
    );

    try {
      const recirculationUrl = `${API_URL}/wp/v1/lookbook/${lookbookId}/recirc?ckey=${DEFAULT_CKEY}&mp_lang=${language}`;
      const recirculationRes = await momentFetcher.fetch(recirculationUrl);
      const recirculationResponse: LightboxRootObject =
        await recirculationRes.json();
      logger?.log(
        `generateFetchLookbookRecirculationQuery - recirculation fetched from\n${recirculationUrl}`
      );
      return recirculationResponse;
    } catch (error) {
      console.error('Error fetching recirculation data:', error);
      throw error;
    }
  };
};
